// Teklifler (C42–C45): yeni ulaşım planı, plan düzenleme, mevcut vs önerilen, güvenli paylaşım, rota üzerine yorum.
// Yollar /operasyon altına göre; izin modülü `proposals` (Sahip ve Planlamacı; Operasyon rolünde yok).
import { Route } from 'react-router';
import { guard, load } from '../route-utils';

const ProposalList = load(() => import('./ProposalList'), 'ProposalList');
const ProposalNew = load(() => import('./ProposalNew'), 'ProposalNew');
const Proposal = load(() => import('./Proposal'), 'Proposal');
const PlanEditor = load(() => import('./PlanEditor'), 'PlanEditor');
const ProposalCompare = load(() => import('./ProposalCompare'), 'ProposalCompare');
const ProposalShare = load(() => import('./ProposalShare'), 'ProposalShare');
const ProposalComments = load(() => import('./ProposalComments'), 'ProposalComments');

export const proposalsRoutes = (
  <>
    <Route path="teklifler" element={guard(ProposalList, 'proposals')} />
    <Route path="teklifler/yeni" element={guard(ProposalNew, 'proposals', { action: 'edit' })} />
    <Route path="teklifler/:id" element={guard(Proposal, 'proposals')} />
    <Route path="teklifler/:id/duzenle" element={guard(PlanEditor, 'proposals')} />
    <Route path="teklifler/:id/karsilastir" element={guard(ProposalCompare, 'proposals')} />
    <Route path="teklifler/:id/paylas" element={guard(ProposalShare, 'proposals')} />
    <Route path="teklifler/:id/yorumlar" element={guard(ProposalComments, 'proposals')} />
  </>
);
